import { ExemptionExpirationStatusEnum } from '@commenda/api/new-sales-tax/customer/types';
import {
  CertificateTypeEnum,
  ExemptionIdTypeEnum,
  ExemptionReasonEnum,
  ExemptionStatusEnum,
} from '@commenda/api/new-sales-tax/exemptions';
import { SelectOption } from '../types';

const CERTIFICATE_TYPE_ENUM_TO_LABEL_MAP = {
  [CertificateTypeEnum.MTC]: 'Multi-State Tax Certificate (MTC)',
  [CertificateTypeEnum.SST]: 'Streamlined Sales Tax (SST)',
  [CertificateTypeEnum.SINGLE_STATE]: 'Single State Exemption',
};

export const CERTIFICATE_TYPE_ENUM_TO_TEXT_MAP = {
  [CertificateTypeEnum.MTC]: 'MTC',
  [CertificateTypeEnum.SST]: 'SST',
  [CertificateTypeEnum.SINGLE_STATE]: 'Single State',
};

export const EXEMPTION_STATUS_ENUM_TO_TEXT_MAP = {
  [ExemptionStatusEnum.ACTIVE]: 'Active',
  [ExemptionStatusEnum.INACTIVE]: 'Inactive',
};

export const CERTIFICATE_TYPE_OPTIONS: SelectOption<CertificateTypeEnum>[] = [
  {
    value: CertificateTypeEnum.MTC,
    label: CERTIFICATE_TYPE_ENUM_TO_LABEL_MAP[CertificateTypeEnum.MTC],
  },
  {
    value: CertificateTypeEnum.SST,
    label: CERTIFICATE_TYPE_ENUM_TO_LABEL_MAP[CertificateTypeEnum.SST],
  },
  {
    value: CertificateTypeEnum.SINGLE_STATE,
    label: CERTIFICATE_TYPE_ENUM_TO_LABEL_MAP[CertificateTypeEnum.SINGLE_STATE],
  },
];

export const EXEMPTION_ID_TYPE_OPTIONS: SelectOption<ExemptionIdTypeEnum>[] = [
  {
    value: ExemptionIdTypeEnum.FEIN,
    label: 'Employer Identification Number (FEIN)',
  },
  { value: ExemptionIdTypeEnum.TIN, label: 'Tax Identification Number (TIN)' },
  { value: ExemptionIdTypeEnum.DL, label: 'Driver’s License (DL)' },
  { value: ExemptionIdTypeEnum.OTHER, label: 'Other' },
];

export const EXEMPTION_ID_TYPE_NAME_MAP = {
  [ExemptionIdTypeEnum.FEIN]: 'Employer Identification Number (FEIN)',
  [ExemptionIdTypeEnum.TIN]: 'Tax Identification Number (TIN)',
  [ExemptionIdTypeEnum.DL]: 'Driver’s License (DL)',
  [ExemptionIdTypeEnum.OTHER]: 'Other',
};

export const EXEMPTION_STATUS_OPTIONS: SelectOption<ExemptionStatusEnum>[] = [
  {
    value: ExemptionStatusEnum.ACTIVE,
    label: EXEMPTION_STATUS_ENUM_TO_TEXT_MAP[ExemptionStatusEnum.ACTIVE],
  },
  {
    value: ExemptionStatusEnum.INACTIVE,
    label: EXEMPTION_STATUS_ENUM_TO_TEXT_MAP[ExemptionStatusEnum.INACTIVE],
  },
];

export const EXEMPTION_REASON_OPTIONS: SelectOption<ExemptionReasonEnum>[] = [
  { value: ExemptionReasonEnum.PURPOSE_RESALE, label: 'Resale' },
  {
    value: ExemptionReasonEnum.ENTITY_TYPE_NONPROFIT,
    label: 'Non-Profit Entity',
  },
  {
    value: ExemptionReasonEnum.GOVERNMENT,
    label: 'Government Entity',
  },
  {
    value: ExemptionReasonEnum.MANUFACTURER,
    label: 'Manufacturer',
  },
  {
    value: ExemptionReasonEnum.AGRICULTURAL,
    label: 'Agricultural',
  },
  {
    value: ExemptionReasonEnum.OTHER,
    label: 'Other',
  },
];
export const EXEMPTION_REASON_NAME_MAP = {
  [ExemptionReasonEnum.PURPOSE_RESALE]: 'Resale',
  [ExemptionReasonEnum.ENTITY_TYPE_NONPROFIT]: 'Non-Profit Entity',
  [ExemptionReasonEnum.GOVERNMENT]: 'Government Entity',
  [ExemptionReasonEnum.MANUFACTURER]: 'Manufacturer',
  [ExemptionReasonEnum.AGRICULTURAL]: 'Agricultural',
  [ExemptionReasonEnum.OTHER]: 'Other',
};

export const EXPIRATION_STATUS_OPTIONS: SelectOption<ExemptionExpirationStatusEnum>[] =
  [
    { value: ExemptionExpirationStatusEnum.EXPIRED, label: 'Expired' },
    { value: ExemptionExpirationStatusEnum.NON_EXPIRED, label: 'Non-Expired' },
  ];

export const CERTIFICATE_FILE_CONFIG = {
  maxSize: 10 * 1024 * 1024, // 10MB
  acceptedTypes: {
    'application/pdf': ['.pdf'],
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
  },
  message: 'PNG, JPG & PDF accepted (max. 10 MB)',
};
